import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const C = {
  brand: "#1C2127", brandMid: "#252B33", gold: "#C8A96E", goldMuted: "rgba(200,169,110,0.12)",
  cream: "#FAF8F5", white: "#FFFFFF", g200: "#E3E1DC", g400: "#A8A49C", g500: "#7A766E",
  g700: "#3D3A34", g900: "#1A1815", red: "#B5443A",
};

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await login(email, password); }
    catch (err) { setError(err.message || "Invalid credentials"); }
    setLoading(false);
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* LEFT — Building Image */}
      <div style={{ width: "50%", position: "relative", overflow: "hidden", background: C.brand }}>
        <img src="/snell.jpg" alt="The Medina at Snell Arcade" style={{
          width: "100%", height: "100%", objectFit: "cover", objectPosition: "center",
          position: "absolute", inset: 0, opacity: 0.85,
        }} />
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(to bottom, rgba(28,33,39,0.3) 0%, rgba(28,33,39,0.6) 60%, rgba(28,33,39,0.92) 100%)",
        }} />
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "60px", zIndex: 2 }}>
          <div style={{ fontSize: "13px", letterSpacing: "4px", color: C.gold, fontWeight: 600, marginBottom: "16px" }}>EST. 2024</div>
          <div style={{ fontSize: "42px", fontWeight: 400, color: C.white, lineHeight: 1.15, fontFamily: "'Playfair Display', Georgia, serif", marginBottom: "16px" }}>
            The Medina
          </div>
          <div style={{ fontSize: "15px", color: "rgba(255,255,255,0.6)", lineHeight: 1.7, maxWidth: "420px" }}>
            A private membership club for Tampa Bay's most connected professionals.
            Where relationships are cultivated, not collected.
          </div>
          <div style={{ width: "60px", height: "2px", background: C.gold, marginTop: "28px" }} />
        </div>
      </div>

      {/* RIGHT — Login Form */}
      <div style={{ flex: 1, background: C.cream, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "60px", position: "relative" }}>
        <div style={{ width: "100%", maxWidth: "400px", animation: "fadeIn 0.6s ease" }}>
          <div style={{ width: 52, height: 52, border: `2px solid ${C.gold}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 40 }}>
            <span style={{ fontSize: 26, color: C.gold, fontFamily: "'Playfair Display', Georgia, serif" }}>M</span>
          </div>

          <h2 style={{ fontSize: 28, fontWeight: 400, color: C.g900, marginBottom: 8, fontFamily: "'Playfair Display', Georgia, serif" }}>Welcome Back</h2>
          <p style={{ fontSize: 14, color: C.g500, marginBottom: 36 }}>Sign in to access your member portal</p>

          {error && (
            <div style={{ padding: "10px 14px", background: "rgba(181,68,58,0.08)", border: "1px solid rgba(181,68,58,0.2)", borderRadius: 6, marginBottom: 20, fontSize: 13, color: C.red }}>{error}</div>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 500, color: C.g700, letterSpacing: 0.3, display: "block", marginBottom: 6 }}>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="member@themedina.com" required
                style={{ width: "100%", padding: "12px 14px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, color: C.g900, background: C.white }} />
            </div>

            <div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 500, color: C.g700 }}>Password</label>
                <button type="button" style={{ background: "none", border: "none", color: C.gold, fontSize: 13, fontWeight: 500 }}>Forgot password?</button>
              </div>
              <div style={{ position: "relative" }}>
                <input type={showPw ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" required
                  style={{ width: "100%", padding: "12px 14px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, color: C.g900, background: C.white }} />
                <button type="button" onClick={() => setShowPw(!showPw)} style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: C.g400, display: "flex", padding: 4 }}>
                  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={{
              width: "100%", padding: 13, background: C.brand, color: C.white, border: "none", borderRadius: 6,
              fontSize: 15, fontWeight: 600, marginTop: 4, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 48,
              opacity: loading ? 0.85 : 1,
            }}>
              {loading ? <div style={{ width: 20, height: 20, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: C.white, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} /> : "Sign In"}
            </button>
          </form>
        </div>
        <div style={{ position: "absolute", bottom: 24, fontSize: 12, color: C.g400 }}>© 2026 The Medina. All rights reserved.</div>
      </div>
    </div>
  );
}
